import React from 'react';
import { Dialog, Spinner } from '@economic/taco';
import { t } from '../../../../../../shared/components/l10n/l10n';

export default function MoneyflowLoadingDialog({ hide, open }: { hide: () => void; open: boolean }) {
    return (
        <Dialog open={open} onClose={hide} size="md">
            <Dialog.Content aria-label={t`FORM_BOOKANDSEND_MONEYFLOW_LOADING_HEADER`} className="moneyflow-dialog">
                <Dialog.Title>{t`FORM_BOOKANDSEND_MONEYFLOW_LOADING_HEADER`}</Dialog.Title>

                <Spinner />
            </Dialog.Content>
        </Dialog>
    );
}
